// extracted by mini-css-extract-plugin
module.exports = {"brandSecondary":"brand_secondary_button-module--brandSecondary--2W9y3"};